import { render } from "./flowManagement.vue?vue&type=template&id=a30e584c&scoped=true"
import script from "./flowManagement.vue?vue&type=script&lang=js"
export * from "./flowManagement.vue?vue&type=script&lang=js"

import "./flowManagement.vue?vue&type=style&index=0&id=a30e584c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a30e584c"

export default script